import React from "react"
import { differenceInDays } from "date-fns"
import { Divida } from "../../../../../../../types/divida-interface"

interface TabelaParcelasDataProps {
  prestacoes: Divida[]
}

export const TabelaParcelasData = ({ prestacoes }: TabelaParcelasDataProps) => {

  function formatDate(date: string) {
    const [dia, mes, ano] = date.split('/')
    return `${mes}/${dia}/${ano}`
  }
  return (
    <div className="my-2">
      <div className="overflow-x-hidden">
        <div className="inline-block w-full align-middle">
          <div className="max-h-[150px] overflow-hidden overflow-y-auto rounded-sm  border-2">
            <table className=" w-full  border-collapse divide-y divide-gray-200">
              <thead className="sticky top-0 bg-gray-200">
                <tr>
                  <th scope="col" className="th-parcelas">
                    {/* Checkbox */}
                  </th>
                  <th scope="col" className="th-parcelas">
                    Contrato
                  </th>
                  <th scope="col" className="th-parcelas">
                    Parcelas
                  </th>
                  <th scope="col" className="th-parcelas">
                    Vencimento
                  </th>
                  <th scope="col" className="th-parcelas">
                    Atraso
                  </th>
                  <th scope="col" className="th-parcelas">
                    Valor Parc.
                  </th>
                  <th scope="col" className="th-parcelas">
                    Juros
                  </th>
                  <th scope="col" className="th-parcelas">
                    Multa
                  </th>
                  <th scope="col" className="th-parcelas">
                    Valor Desc.
                  </th>
                  <th scope="col" className="th-parcelas">
                    Total atual
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {
                  prestacoes && prestacoes?.length > 0 && prestacoes.map((p, i) => (
                    <tr key={p.id}>
                      <td className="td-parcelas">
                        <input
                          type="checkbox"
                          className="h-3 w-3 rounded-sm accent-rose-600"
                        />
                      </td>
                      <td className="td-parcelas">
                        <span>{p.contrato}</span>
                      </td>
                      <td className="td-parcelas">
                        <span>{i + 1}</span>
                      </td>
                      <td className="td-parcelas">
                        <span>{p.datvenci}</span>
                      </td>
                      <td className="td-parcelas">
                        <span>{differenceInDays(new Date(), new Date(formatDate(p.datvenci)))}</span>
                      </td>
                      <td className="td-parcelas">
                        <span>{p.valorprincipal}</span>
                      </td>
                      <td className="td-parcelas">
                        <span>{p.juros}</span>
                      </td>
                      <td className="td-parcelas">
                        <span>{p.multa}</span>
                      </td>
                      <td className="td-parcelas">
                        <span>{p.desconto}</span>
                      </td>
                      <td className="td-parcelas">
                        <span>{p.valorpago}</span>
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}